import { Component } from '@angular/core';

@Component({
  selector: 'dp-blank-container',
  templateUrl: './blank-container.component.html',
})
export class BlankContainerComponent  {
}
